<app-spinner [isLoading]="loading()" [isFixedPosition]="true">
  <div class="container" [class.container--success]="isSuccess()">
    <ng-container *ngIf="!isSuccess(); else successState">
      <div class="content">
        <h3>{{ 'text.EnterVerificationCode' | translate }}</h3>

        <p class="check-spam">{{ 'text.CheckSpamFolder' | translate }}</p>

        <form [formGroup]="verificationForm" (ngSubmit)="onSubmit()">
          <div class="input-with-timer">
            <input type="text" formControlName="validationCode" />
            <span *ngIf="verificationTimer() as seconds" class="timer">{{
              format(seconds)
            }}</span>
          </div>
          <mat-error *ngIf="isOTPCodeNotValid()" class="validation-message">
            {{ 'message.CodeNotValid' | translate }}
          </mat-error>
          <mat-error *ngIf="isOTPCodeExpired()" class="validation-message">
            {{ 'message.OTPCodeExpired' | translate }}
          </mat-error>
          <div class="code-action">
            <span class="not-received-label">{{
              'text.IfNotReceived' | translate
            }}</span>
            <span
              (click)="resendVerificationCode()"
              class="not-received-action"
              [class.disabled]="resendCooldownSeconds() > 0"
              >{{ 'text.RequestVerificationCode' | translate }}</span
            >
            <strong
              *ngIf="resendCooldownSeconds() as seconds"
              class="resend-cooldown"
              >({{ seconds }})</strong
            >
          </div>
        </form>
      </div>

      <div class="actions">
        <button
          class="actions__item actions__item--green"
          type="submit"
          [disabled]="verificationForm.invalid || loading()"
          (click)="onSubmit()"
        >
        {{ 'label.Approve' | translate }}
        </button>
        <button
          (click)="onClose()"
          class="actions__item actions__item--grey"
          type="button"
        >
          {{ 'label.Cancel' | translate }}
        </button>
      </div>
    </ng-container>

    <ng-template #successState>
      <div class="success">
        <div class="success__row">
          <span class="success__icon" aria-hidden="true">
            <svg-icon svgClass="icon" src="assets/icons/check-round.svg"></svg-icon>
          </span>
          <p class="success__message">
            {{ 'message.EmailUpdateSuccess' | translate }}
          </p>
        </div>
        <button
          (click)="onClose()"
          class="success__close"
          type="button"
          cdkFocusInitial
        >
          {{ 'label.Close' | translate }}
        </button>
      </div>
    </ng-template>
  </div>
</app-spinner>
